import React from 'react';
import Modal from './Modal';

const DocumentPreview = ({ isOpen, onClose, fileUrl, fileType, fileObj }) => {
  // Helper to get extension from MIME type
  const getExtensionFromMime = (mime) => {
    if (!mime) return '';
    const mimeToExtension = {
      'application/pdf': 'pdf',
      'image/png': 'png',
      'image/jpg': 'jpg',
      'image/jpeg': 'jpeg',
      'image/gif': 'gif',
      'image/webp': 'webp',
      'image/bmp': 'bmp',
    };
    if (mimeToExtension[mime]) return mimeToExtension[mime];
    if (mime.startsWith('image/')) return mime.split('/')[1];
    return '';
  };

  // Helper to get extension from URL
  const getFileExtension = (url) => {
    if (!url || typeof url !== 'string') return '';
    try {
      const cleanUrl = url.split(/[?#]/)[0];
      const lastSegment = cleanUrl.split('/').pop() || '';
      return lastSegment.includes('.') ? lastSegment.split('.').pop().toLowerCase() : '';
    } catch {
      return '';
    }
  };

  // Smart extension getter
  const getExtension = () => {
    if (fileObj && fileObj.type) {
      return getExtensionFromMime(fileObj.type);
    }
    if (fileType) {
      if (fileType.includes('/')) {
        // It's a MIME type
        return getExtensionFromMime(fileType);
      }
      // It's probably an extension string
      return fileType.split(/[?#]/)[0].toLowerCase();
    }
    return getFileExtension(fileUrl);
  };

  const extension = getExtension();

  const renderContent = () => {
    if (!fileUrl) {
      return <p>No document to display.</p>;
    }

    switch (extension) {
      case 'pdf':
        return <iframe src={fileUrl} width="100%" height="500px" title="PDF Preview" />;
      case 'png':
      case 'jpg':
      case 'jpeg':
      case 'gif':
      case 'webp':
      case 'bmp':
        return (
          <img
            src={fileUrl}
            alt="Document Preview"
            style={{ maxWidth: '100%', maxHeight: 500, display: 'block', margin: '0 auto' }}
          />
        );
      default:
        if (fileUrl) {
          return (
            <div>
              <img
                src={fileUrl}
                alt="Document Preview"
                style={{ maxWidth: '100%', maxHeight: 500, display: 'block', margin: '0 auto' }}
                onError={(e) => {
                  e.target.style.display = 'none';
                  if (e.target.parentElement) {
                    const fallback = e.target.parentElement.querySelector('.fallback-message');
                    if (fallback) {
                      fallback.style.display = 'block';
                    }
                  }
                }}
              />
              <div className="fallback-message" style={{ display: 'none', textAlign: 'center' }}>
                <p>Unsupported file type. Please download the file to view.</p>
              </div>
            </div>
          );
        }
        return <p>Unsupported file type. Please download the file to view.</p>;
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Document Preview">
      {renderContent()}
    </Modal>
  );
};

export default DocumentPreview;
